import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import Styles from './PricePill.module.scss'
import cx from 'classnames'

interface Props {
  plan: PaymentPlanKey
  withText?: boolean
}

export const PricePill = ({ plan, withText }: Props) => {
  let text = ''
  let colorClassName = ''

  switch (plan) {
    case PaymentPlanKey.BlazeCreator:
      text = 'Creator'
      colorClassName = Styles.creator
      break
    case PaymentPlanKey.BlazePro:
      text = 'Pro'
      colorClassName = Styles.pro
      break
    case PaymentPlanKey.BlazeTeam:
      text = 'Team'
      colorClassName = Styles.team
      break
    case PaymentPlanKey.BlazeAgency:
      text = 'Agency'
      colorClassName = Styles.agency
      break
    case PaymentPlanKey.BlazeEnterprise:
      text = 'Enterprise'
      colorClassName = Styles.enterprise
      break
  }

  return (
    <div
      className={cx(Styles.container, colorClassName, {
        [Styles.withText]: withText,
      })}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.5515 8.13017C13.735 7.75855 14.2649 7.75855 14.4483 8.13017L15.647 10.559C15.7198 10.7065 15.8606 10.8088 16.0234 10.8325L18.7038 11.222C19.1139 11.2816 19.2776 11.7855 18.9809 12.0748L17.0414 13.9654C16.9235 14.0802 16.8697 14.2457 16.8976 14.4079L17.3554 17.0774C17.4255 17.4859 16.9968 17.7974 16.6299 17.6045L14.2326 16.3441C14.0869 16.2676 13.9129 16.2676 13.7672 16.3441L11.3699 17.6045C11.0031 17.7974 10.5744 17.4859 10.6444 17.0774L11.1023 14.4079C11.1301 14.2457 11.0763 14.0802 10.9585 13.9654L9.01896 12.0748C8.7222 11.7855 8.88595 11.2816 9.29606 11.222L11.9764 10.8325C12.1393 10.8088 12.28 10.7065 12.3529 10.559L13.5515 8.13017Z"
          fill="white"
        />
      </svg>
      {withText && <div className={Styles.text}>{text}</div>}
    </div>
  )
}
